// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../routes/paths';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'Startseite',
    icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
    path: '/'
  },
  {
    title: 'Über uns',
    icon: <Iconify icon={'bi:people-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.about
  },
  {
    title: 'Kontakt',
    icon: <Iconify icon={'fluent:contact-card-16-filled'} {...ICON_SIZE} />,
    path: PATH_PAGE.contact
  },
  {
    title: 'Demo',
    icon: <Iconify icon={'eva:flash-fill'} {...ICON_SIZE} />,
    path: PATH_DASHBOARD.brand('demo').store('demo').orders.today
  }
];

export default menuConfig;
